import {ValueObject} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'

export class MessagingChannelContextValueObject extends ValueObject {
  #channelId
  #tenant
  #buyerId
  #sellerId
  #entityType
  #entityId

  static create({channelId, tenant, buyerId, sellerId, entityType, entityId}) {
    return new MessagingChannelContextValueObject({
      channelId,
      tenant,
      buyerId,
      sellerId,
      entityType,
      entityId: IdSharedValueObject.createFromPrimitives({id: entityId})
    })
  }

  constructor({channelId, tenant, buyerId, sellerId, entityType, entityId}) {
    super()

    this.#channelId = channelId
    this.#tenant = tenant
    this.#buyerId = buyerId
    this.#sellerId = sellerId
    this.#entityType = entityType
    this.#entityId = entityId
  }

  toJSON() {
    return {
      channelId: this.#channelId,
      tenant: this.#tenant,
      buyerId: this.#buyerId,
      sellerId: this.#sellerId,
      entityType: this.#entityType,
      entityId: this.#entityId.value
    }
  }
}
